import { Component, ViewChild, OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { DocumentoService } from 'src/app/services/documento.service';

import { MatDialog } from '@angular/material';
import { GLOBAL } from 'src/app/services/global';
import { switchAll } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from "../../../services/user.service";
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
declare const swal: any;
const url = GLOBAL.url;

declare var jQuery: any;
declare var $: any;
const uri = url + 'upload/file';
@Component({
    selector: "page-archivos",
    templateUrl: "./archivos.component.html",
    styleUrls: ["./archivos.component.css"],
    providers: [DocumentoService]

})

export class ArchivosComponent implements OnInit {
    panelOpenState = false;

    @ViewChild('openModalMessageFiles') openModalMessageFiles: TemplateRef<any>;
    @ViewChild('modalArchivos') modalArchivos: TemplateRef<any>;
    @ViewChild('modalAdjuntos') modalAdjuntos: TemplateRef<any>;

    uploader: FileUploader = new FileUploader({ url: uri })
    attachmentList: any = [];
    public hasBaseDropZoneOver: boolean = false;
    public hasOnFileDrop: boolean = false;
    public inputList = [];
    labelDrop
    inputValue
    form
    isReady = false;
    public archivosForm
    public archivosSubidos = [];
    public archivoSubidoFind = false;
    public cantArSubidosObligatorios = 0;
    public arrayArchivos = [];
    public interval
    private pdfUrl = GLOBAL.pdfUrl;
    public generico = GLOBAL.generico;
    public adjuntoActual
    public enableUpload = false
    public adjuntos = []
    public files = []
    public files2 = []
    public rows = []
    public rows1 = [{ total: 0 }]
    public documentoNombre = ''
    public maxSizeFiles = 75000000
    public actualSizeFiles = 0
    //archivos lista
    nombreForm;
    nombreArchivo;
    inputdatos = [];
    storageDatos = [];
    doc1;
    doc2;
    doc3;
    doc4;
    doc5;
    doc6;
    public demolicion_archivo;
    public test = true
    documents
    docsDetectChange = new BehaviorSubject([])
    cargando = false
    archivoCargado
    btnAccept = false
    peso
    pase = false
    probando_archivos
    public titulo
    isFilesOK = false


    constructor(private _documentosServices: DocumentoService, private dialog: MatDialog, private cd: ChangeDetectorRef, private spinner: NgxSpinnerService) {
        this.nombreArchivo = ''

        this.form = localStorage.getItem("form")

        this.demolicion_archivo = localStorage.getItem("archivo_demolicion")

        if (!JSON.parse(localStorage.getItem("adjuntos"))) {
            localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
        } else {
            this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
        }

        if (localStorage.getItem("ZipURL")) {
            console.log("ZipURL", localStorage.getItem("ZipURL"));
            this.isFilesOK = true
        }



        this.uploader.onAfterAddingFile = (file) => {
            file.withCredentials = false
        }

        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.attachmentList.push(response);
        }

        /*     this.documents = JSON.parse(localStorage.getItem("archivos_antecedentes"))
     */

    }


    ngOnInit() {
        this.spinner.show()
        this.getUploaders();


        var intervall
        intervall = setInterval(() => {
            this.documents = JSON.parse(localStorage.getItem("antecedentes"))
            let archivos = JSON.parse(localStorage.getItem("archivos_marcados"))
            this.titulo = localStorage.getItem("formTitle")

            /* if (archivos['archivosSubidos'] === true) {

            } */

            if (this.documents) {
                if (this.documents.length > 0) {
                    this.llenarTabla()
                    clearInterval(intervall)
                }

                this.spinner.hide()
              /*   this.dialog.open(this.openModalMessageFiles) */
            } else {
                clearInterval(intervall)
                this.rows.push({ id: 0, name: this.titulo, new: false })
                this.rows = [...this.rows];
                this.docsDetectChange.next(this.rows)
                this.spinner.hide()
               /*  this.dialog.open(this.openModalMessageFiles) */
            }



        }, 5000);
    }

    ngAfterViewChecked() {
        var sol = localStorage.getItem("docs_checkedOK");

        if (sol == "cambiado") {
            this.cargando = true
            localStorage.setItem("docs_checkedOK", "listo")

            var x = JSON.parse(localStorage.getItem("docs_checked"));
            if (this.generico) {
                if (this.documents && x) {

                    if (this.documents.length != x.length) {
                        this.documents = JSON.parse(localStorage.getItem("docs_checked"));
                        this.llenarTabla()
                    } else {
                        for (let index = 0; index < this.documents.length; index++) {
                            if (this.documents[index] != x[index]) {
                                this.documents = JSON.parse(localStorage.getItem("docs_checked"));
                                this.llenarTabla()
                            }
                        }
                    }
                }
            } else {
                this.rows = []
                this.files = []
                this.actualSizeFiles = 0

                var archivos = localStorage.getItem("archivos_marcados")
                if (archivos) {
                    var subidos = { "archivosSubidos": false };
                    localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
                }

                var cont = 0
                if (x.archivos.length > 0) {


                    for (let index = 0; index < x.archivos.length; index++) {
                        this.rows.push({ id: cont, name: x.archivos[index].name, new: false })
                        cont++;
                    }
                    this.cargando = false
                    this.rows = [...this.rows];
                    this.docsDetectChange.next(this.rows)
                }
            }

        }



    }


    llenarTabla() {

        this.rows = []
        this.files = []
        this.actualSizeFiles = 0

        var archivos = localStorage.getItem("archivos_marcados")
        /*     if (archivos) {
                var subidos = { "archivosSubidos": false };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
            } */

        var cont = 0
        if (this.documents.length > 0) {


            for (let index = 0; index < this.documents.length; index++) {
                this.rows.push({ id: cont, name: this.documents[index].nombre, new: false })
                cont++;

                if (index + 1 == this.documents.length) {
                    this.rows.push({ id: cont, name: this.titulo, new: false })
                }

            }
            this.cargando = false
            this.rows = [...this.rows];
            this.docsDetectChange.next(this.rows)
        }

        if (this.rows.length > 0) {
            for (let index = 0; index < this.rows.length; index++) {
                if (JSON.parse(localStorage.getItem("archivos_cargados"))) {
                    let adjuntosBorrador = JSON.parse(localStorage.getItem("archivos_cargados"));

                    for (let i = 0; i < adjuntosBorrador.length; i++) {
                        const adjBorr = adjuntosBorrador[i];
                        console.log("adjBorr", adjBorr.name, "==", this.rows[index].name);

                        if (adjBorr.name == this.rows[index].name) {
                            console.log("adjBorr", adjBorr);
                            this.rows[index].archivo = adjBorr.doc
                            this.rows[index].peso = adjBorr.size

                        }
                    }
                }
            }
        }
    }

    cerrarModal() {
        this.nombreArchivo = ''
        this.documentoNombre = ''
        this.dialog.closeAll();
    }

    fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }
    onFileDrop(e: any, archivo = null) {

        this.archivoSubidoFind = false;
        for (let i = 0; i < this.archivosForm.length; i++) {
            if (this.archivosForm[i].name == archivo.name) {
                this.archivosForm[i].ready = true;
            }
        }
        this.archivosSubidos.push(archivo)

        if (this.archivosSubidos) {


            if (this.arrayArchivos.length == 0) {
                this.arrayArchivos.push(archivo)
            } else {

                for (let i = 0; i < this.arrayArchivos.length; i++) {
                    if (this.arrayArchivos[i].name == archivo.name) {

                        this.archivoSubidoFind = true;
                    }


                }
            }
        }

        if (!this.archivoSubidoFind) {
            this.arrayArchivos.push(archivo)
            if (archivo.obligatorio) {
                this.cantArSubidosObligatorios = this.cantArSubidosObligatorios + 1

            }
        }



        // for (let i = 0; i < this.inputList.length; i++) {
        //     if(this.inputList[i].name == a){
        //         this.inputList[i].ready = true;
        //     }

        // }
        this.nombreForm = archivo.name;
        this.unir(archivo.name);
    }

    onInsert(row) {
        /* this.revisarTabla() */
        /*  var subidos = { "archivosSubidos": false };
         localStorage.setItem("archivos_marcados", JSON.stringify(subidos)); */
    }

    revisarTabla() {
        var bandera = true
        for (let tabla = 0; tabla < this.rows.length; tabla++) {

            if (!this.rows[tabla].archivo || this.rows[tabla].archivo == "") {
                bandera = false
            }

            if ((tabla + 1) == this.rows.length) {
                if (bandera == true) {
                    this.pase = true
                }
            }
        }
    }

    marcarArchivos() {

        var subidos = { "archivosSubidos": true };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        swal({
            type: 'success',
            title: 'Archivos cargados',
            text: '<p>ya puedes continuar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        }).then(
            () => {
                window.scrollTo(0, document.body.scrollHeight);
            }
        );


    }


    fileInput(archivo) {
        console.log(archivo)

    }

    getUploaders() {
        var intervalStart = false

        if (!intervalStart) {
            this.interval = setInterval(() => {
                if (localStorage.getItem("archivos2")) {
                    intervalStart = true
                }
            }, 2000)
        }

        if (intervalStart) {
            this.archivosForm = JSON.parse(localStorage.getItem("archivos2"))
        }

        this._documentosServices.getUploaders().subscribe(
            response => {
                if (this.generico == true) {
                    this.form = localStorage.getItem("formId")
                } else {
                    this.form = localStorage.getItem("form")
                }

                if (this.form == '5.8' && (this.demolicion_archivo == false || this.demolicion_archivo == "false")) {
                    var contador = 0;
                    for (let i = 0; i < response.documentos.length; i++) {

                        if (this.form == response.documentos[i].name) {



                            while (contador < 6) {
                                this.arrayArchivos.push(response.documentos[i].archivos[contador])

                                contador++

                            }
                            this.archivosForm = this.arrayArchivos


                        }
                    }
                } else {
                    for (let i = 0; i < response.documentos.length; i++) {

                        if (this.form == response.documentos[i].name) {
                            this.archivosForm = response.documentos[i].archivos
                        }
                    }
                }


            },
            error => {
                console.log(error);
            }
        )
    }


    removeAll() {
        for (let i = 0; i < this.inputList.length; i++) {
            if (this.inputList[i].ready) {
                this.inputList[i].ready = false;
            }
        }
        this.inputdatos.splice(0);
        //localStorage.setItem("archivos", JSON.stringify([]));
    }

    removeFile(nombre) {

        var index;
        for (let i = 0; i < this.inputdatos.length; i++) {
            if (this.inputdatos[i].nombreArchivo == nombre) {
                for (let x = 0; x < this.inputList.length; x++) {
                    if (this.inputList[x].name == this.inputdatos[i].nombreForm) {
                        index = i;
                        this.inputList[x].ready = false;
                    }
                }
            }
        }
        this.inputdatos.splice(index, 1);
        //this.setStorage();
    }

    unir(fileType = '') {
        this.uploader.queue[this.uploader.queue.length - 1].file.name = fileType + '-' + new Date().getTime() + '-' + this.uploader.queue[this.uploader.queue.length - 1].file.name
        this.nombreArchivo = this.uploader.queue[this.uploader.queue.length - 1].file.name;
        this.adjuntoActual = this.uploader.queue[this.uploader.queue.length - 1].file.name

        this.inputdatos.push({

            'linkArchivo': `${this.pdfUrl}/${this.nombreArchivo}`,
            'nombreForm': this.nombreForm,
        });
        localStorage.removeItem("archivos")
        localStorage.setItem("archivos", JSON.stringify(this.inputdatos));

    }
    /*
        onFileAdd(ev: any, file){
     
            //si no tiene informacion...
     
     
            let actualAdjuntos = localStorage.getItem("adjuntos");
            this.adjuntos = JSON.parse(actualAdjuntos);
     
                this. adjuntos = this.adjuntos.concat({
                    nombre: 
                })
     
                localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
                this.form.reset();
        }
        */
    openAdjuntosModal() {
        this.dialog.open(this.modalAdjuntos, { disableClose: true });
    }

    cancelarAdjunto() {
        let tmpName = this.uploader.queue[this.uploader.queue.length - 1].file.name
        this.removeFile(tmpName)
        this.uploader.queue[this.uploader.queue.length - 1].remove()
        localStorage.removeItem("archivos")
        localStorage.setItem("archivos", JSON.stringify(this.inputdatos))
        this.enableUpload = false
        this.nombreArchivo = ''
    }

    adjuntoSave(fileName = null) {
        var subidos = { "archivos_nuevos": true };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        this.btnAccept = false
        /* let actualRow = localStorage.getItem("adjuntos");
        this.rows = JSON.parse(actualRow); */
        var id = this.rows.length

        this.rows = this.rows.concat({
            id: id,
            name: this.documentoNombre,
            archivo: this.nombreArchivo,
            peso: this.peso,
            new: true
        })

        this.rows = [...this.rows];
        this.docsDetectChange.next(this.rows)
        this.peso = ''
        this.archivoCargado = ''
        this.cerrarModal();


    }

    uploadAll() {
        /*
         
           
            this.marcarArchivos()
            this._documentosServices.uploadFiles(this.uploader.queue).subscribe(
                response => {
                },
                error => {
                    console.log(error);
                }
            )
            */

    }

    deleteFileAntiguo(index = null) {
        if (index != null) {
            //recalcular size
            let fil: File
            fil = this.files[index]
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
            //Remove file
            this.files.splice(index, 1)
            let actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.rows.splice(index, 1)
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        } else {
            //recalcular size
            let fil: File
            fil = this.files[this.files.length - 1]
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
            //Remove file
            this.files.splice(this.files.length - 1, 1)
            let actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.rows.splice(this.rows.length - 1, 1)
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        }
    }

    handleFileInput(files: FileList) {
        let file: File
        file = files.item(0)

        console.log("FILEEEE", file);
        if (file.type == "application/pdf") {
            let actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.nombreArchivo = files.item(0).name
            this.files.push({ name: this.documentoNombre, doc: file })
            let peso = (files.item(0).size / 1000000) + ' MB'
            this.peso = (files.item(0).size / 1000000) + ' MB'
            this.rows = this.rows.concat({
                name: this.documentoNombre,
                archivo: this.nombreArchivo,
                peso: peso
            })
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
            this.actualSizeFiles = this.actualSizeFiles + files.item(0).size

            //check max size file
            this.checksSize(this.files.length - 1)
        } else {
            swal({
                icon: 'warning',
                title: 'Tipo de archivo no permitido',
                text: '<p>Estimado usuario, se le recuerda que sólo se aceptarán archivos tipo pdf para la subida de documentación.</p>',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            })
        }
    }


    handleFileInput2(files: FileList, row) {
        let file: File
        file = files.item(0)


        console.log("FILEEEE2", file);

        if (file.type == "application/pdf") {
            if (row.id || row.id == 0) {
                for (let index = 0; index < this.rows.length; index++) {
                    if (this.rows[index].id == row.id) {
                        this.nombreArchivo = files.item(0).name
                        let peso = (files.item(0).size / 1000000) + ' MB'

                        this.rows[index].archivo = this.nombreArchivo
                        this.rows[index].peso = peso
                        this.rows[index].new = false

                        this.files[index] = ({ name: this.rows[index].name, doc: file })
                        this.files2[index] = ({ name: this.rows[index].name, doc: file.name, size: file.size })
                    }
                }
            } else {
                this.archivoCargado = files.item(0)
                if (files.item(0).name && this.documentoNombre != '') {
                    this.btnAccept = true


                    let actualRow = localStorage.getItem("adjuntos");
                    /*   this.rows = JSON.parse(actualRow); */
                    this.nombreArchivo = files.item(0).name


                    /*  this.files.push({ name: this.documentoNombre, doc: file }) */

                    this.files[this.rows.length] = ({ name: this.documentoNombre, doc: file })
                    this.files2[this.rows.length] = ({ name: this.documentoNombre, doc: file.name, size: file.size })
                    this.peso = (files.item(0).size / 1000000) + ' MB'
                }
            }
            this.actualSizeFiles = this.actualSizeFiles + files.item(0).size
            this.rows1[0].total = this.actualSizeFiles
            this.rows1 = [...this.rows1];

            console.log("files", this.files);

            localStorage.setItem("archivos_cargados", JSON.stringify(this.files2));

            //check max size file
            this.checksSize(this.files.length - 1)

            this.revisarTabla()
        } else {
            swal({
                icon: 'warning',
                title: 'Tipo de archivo no permitido',
                text: '<p>Estimado usuario, se le recuerda que sólo se aceptarán archivos tipo pdf para la subida de documentación.</p>',
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            })
        }
    }




    checksSize(index = null) {
        if (this.actualSizeFiles > this.maxSizeFiles) {
            this.deleteFile(index)
            this.alertMaxsize()
        }
    }

    alertMaxsize() {
        swal({
            icon: 'error',
            title: 'Supero el máximo de MB para tus adjuntos',
            text: '<p>Usted cuenta con un máximo de <strong>75 MB</strong> para utilizar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        })
    }

    uploadAllfiles() {
        let formType = (this.form) ? this.form : 'Generico';
        this.spinner.show();


        this._documentosServices.uploadFiles(this.files, formType).subscribe(
            response => {
                console.log("response", response)
                this.spinner.hide();
                var subidos = { "archivosSubidos": true };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                let alert = { icon: 'success', text: '', title: '' }

                if (response.code == 99 && response.url) {
                    alert.icon = 'success'
                    alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>'
                    alert.title = 'Archivos cargados'
                    localStorage.setItem('ZipURL', response.url)
                } else if (response.code == 98) {
                    alert.icon = 'error'
                    alert.text = '<p>No se adjuntaron documentos</p>'
                    alert.title = 'Archivos no cargados'
                } else if (response.code == 97) {
                    alert.icon = 'error'
                    alert.text = '<p>No se adjuntaron documentos</p>'
                    alert.title = 'Archivos no cargados'
                } else if (response.code == 96) {
                    alert.icon = 'error'
                    alert.text = '<p>Archivos no permitidos</p>'
                    alert.title = 'Archivos no cargados'
                }
                else {
                    alert.icon = 'error'
                    alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
                    alert.title = 'Archivos no cargados'
                }

                swal({
                    icon: alert.icon,
                    title: alert.title,
                    text: alert.text,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(
                    () => {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                );

            },
            error => {
                this.spinner.hide();
                console.log("un error", error);
                var subidos = { "archivosSubidos": true };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
                swal({
                    icon: 'error',
                    title: 'Error al subir documentación',
                    text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(
                    () => {
                        window.scrollTo(0, document.body.scrollHeight);
                    }
                );
            }
        )
    }


    deleteFile(files: FileList) {
        if (this.archivoCargado) {


            //recalcular size
            let fil: File
            fil = this.files[this.files.length - 1]
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
            //Remove file
            this.files.splice(this.files.length - 1, 1)
            let actualRow = localStorage.getItem("adjuntos");
            this.archivoCargado = ''

        } else {
            /*   if (files.item(0).name) {
                  this.files.splice(this.files.length - 1, 1)
                  let actualRow = localStorage.getItem("adjuntos");
              } */
            this.btnAccept = false
            this.cerrarModal();
        }
    }

    deleteFile2(row) {
        var zip = localStorage.getItem("ZipURL")
        if (zip) {
            var subidos = { "archivosSubidos": true };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        } else {
            var subidos = { "archivosSubidos": false };
            localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        }

        this.rows.splice(row.id, 1)
        this.files.splice(row.id, 1)

        this.clearSize()
    }

    clearSize() {
        this.actualSizeFiles = 0
        for (let index = 0; index < this.files.length; index++) {
            const element = this.files[index];
            if (element) {
                this.actualSizeFiles = this.actualSizeFiles + element.doc.size
            }
        }
        //check max size file
        this.checksSize(this.files.length - 1)
    }
}
